export enum DvirTypeEnum {
  PreTrip = 'pre-trip',
  Regular = 'regular',
  PostTrip = 'post-trip',
}
